import { AxiosRequestConfig } from "axios"

const getStyles = (): AxiosRequestConfig => ({
    url: '/styles',
    method: 'GET',
})

export { getStyles }